import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = {
  key: 0,
  class: "borderGrey pad20 rad10 mt20"
}
const _hoisted_3 = {
  class: "fl fs18 fw600",
  style: {"width":"200px","line-height":"80px"}
}
const _hoisted_4 = {
  key: 0,
  class: "fl",
  style: {"width":"520px","height":"80px"}
}
const _hoisted_5 = {
  class: "fl",
  style: {"width":"330px"}
}
const _hoisted_6 = { class: "fl ml20 mt20" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = {
  key: 1,
  class: "fl",
  style: {"width":"400px","line-height":"40px"}
}
const _hoisted_11 = { class: "fs13 fw600" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "登録したドメインをグループに割り当てます。", -1)
const _hoisted_15 = { class: "fl ml20 mt3" }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = {
  key: 2,
  class: "alertBg mt40 pad15 rad5 fs13"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = { key: 3 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_24 = { class: "mt20" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("tr", {
  class: "lskyblueBg",
  height: "30"
}, [
  /*#__PURE__*/_createElementVNode("th", { class: "centered fs11" }, "タイプ"),
  /*#__PURE__*/_createElementVNode("th", { class: "centered fs11" }, "ホスト名"),
  /*#__PURE__*/_createElementVNode("th", { class: "centered fs11" }, "バリュー")
], -1)
const _hoisted_26 = {
  width: "150",
  class: "centered"
}
const _hoisted_27 = { class: "fs12" }
const _hoisted_28 = {
  width: "300",
  class: "centered"
}
const _hoisted_29 = {
  width: "400",
  class: "text-left pad10"
}
const _hoisted_30 = ["src", "onClick"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_33 = { key: 4 }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "fs13 fw600" }, "割り当てられたグループ", -1)
const _hoisted_35 = {
  class: "fl",
  style: {"line-height":"40px","width":"300px"}
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["src"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.domain)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.domain.name), 1),
          (_ctx.domain.submit_status < 1000)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.submitStatusText), 1),
                _createElementVNode("button", {
                  type: "submit",
                  class: _normalizeClass(`fl pointer centered circle_button  ${
                        _ctx.buttonActive == `active` ? `skyblueBg` : `lgreyBg`
                    } fs14 rad8 mt15 ml20`),
                  style: {"height":"50px"},
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
                }, _toDisplayString(_ctx.buttonName), 3),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("p", {
                    class: "fl mt12 pointer",
                    style: {"width":"16px"},
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.removeDomain && _ctx.removeDomain(...args)))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
                      width: "16",
                      height: "19"
                    }, null, 8, _hoisted_7)
                  ]),
                  _hoisted_8
                ]),
                _hoisted_9
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, "ステータス: " + _toDisplayString(_ctx.domain.status == 10 ? `アクティブ` : `非アクティブ`), 1),
                _hoisted_12,
                (_ctx.domain.status == 10)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode(_component_SelectTag, {
                        name: "team_names",
                        id: "select_team_name",
                        class: "fl fs14 roundForm noBorder",
                        style: {"width":"180px","min-width":"180px","height":"50px"},
                        options: _ctx.teamNames,
                        defaultOption: null,
                        needUnselect: true,
                        onSelectValue: _ctx.selectTeamName
                      }, null, 8, ["options", "onSelectValue"]),
                      _createElementVNode("button", {
                        type: "submit",
                        class: _normalizeClass(`${
                            _ctx.currentUg && _ctx.teamNames.length > 0 ? `skyblueBg` : `lgreyBg`
                        } fl pointer centered circle_button fs14 rad8 mt5 ml20 `),
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.assignDomainToTeam && _ctx.assignDomainToTeam(...args)))
                      }, " 割り当てる ", 2)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("p", {
                    class: "fl mt12 pointer",
                    style: {"width":"16px"},
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.removeDomain && _ctx.removeDomain(...args)))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
                      width: "16",
                      height: "19"
                    }, null, 8, _hoisted_16)
                  ]),
                  _hoisted_17
                ])
              ])),
          _hoisted_18,
          _hoisted_19,
          (_ctx.domain.invalid_message)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createTextVNode(" サポートからのメッセージ： " + _toDisplayString(_ctx.domain.invalid_message) + " ", 1),
                _hoisted_21
              ]))
            : _createCommentVNode("", true),
          (_ctx.domain.submit_status >= 10 && (_ctx.domain.email_domain_records || []).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("table", null, [
                    _hoisted_25,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.domain.email_domain_records, (rec, recindex) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "centered",
                        height: "100",
                        key: recindex
                      }, [
                        _createElementVNode("td", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, _toDisplayString(rec.type), 1)
                        ]),
                        _createElementVNode("td", _hoisted_28, _toDisplayString(rec.hostname), 1),
                        _createElementVNode("td", _hoisted_29, [
                          _withDirectives(_createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/icons/copy_icon.png`),
                            width: "20",
                            height: "20",
                            class: "fr",
                            onClick: ($event: any) => (_ctx.clickCopyIcon(rec))
                          }, null, 8, _hoisted_30), [
                            [
                              _directive_tooltip,
                              'コピーしました!',
                              void 0,
                              { "outside-click": true }
                            ]
                          ]),
                          _hoisted_31,
                          _createVNode(_component_TextareaTag, {
                            placeholder: "こちらをコピーしてvalue項目に貼り付けてください。",
                            style: {"height":"150px"},
                            class: _normalizeClass(`fs12 roundForm mw100 mt10 recordValue${recindex}`),
                            value: rec.registration_value,
                            onClickTextarea: ($event: any) => (_ctx.clickTextarea(recindex, rec.registration_value))
                          }, null, 8, ["class", "value", "onClickTextarea"])
                        ])
                      ]))
                    }), 128))
                  ]),
                  _hoisted_32
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.Util.isPresent(_ctx.assignedUgs))
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _hoisted_34,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assignedUgs, (ug, ugindex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "w100",
                    key: ugindex
                  }, [
                    _createElementVNode("div", _hoisted_35, _toDisplayString(ug.name), 1),
                    _createElementVNode("p", {
                      class: "fl mt12 pointer",
                      style: {"width":"16px"},
                      onClick: ($event: any) => (_ctx.removeAssign(ug))
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
                        width: "16",
                        height: "19"
                      }, null, 8, _hoisted_37)
                    ], 8, _hoisted_36),
                    _hoisted_38
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}